/**
 * Returns a suitable human-readable name to identify a
 * React component class.
 */
export default function getDisplayName(ComponentClass) {
    return ComponentClass.displayName || ComponentClass.name || 'Component';
}
